export { default } from './ResetPassword.js'



// WEBPACK FOOTER //
// ./src/App/ResetPassword/index.js